import { Env } from '@/configs/env'

const ides = ['vscode']

export function isDebugging(): boolean {
  return ides.includes(process.env.TERM_PROGRAM || '') || process.env[Env.REACT_APP_ENV] === 'local'
}
